import { defa }                 from 'defa-object';
import EndpointModel            from 'scripts/poppet/endpoint-model';
import Model                    from 'scripts/poppet/model'
import OnOff                    from './model-on-off';
import TemperatureConfiguration from './model-temperature-configuration';
import Thermostat               from './model-thermostat';
import DutyCycle                from './model-duty-cycle';
import HeatingZone              from './model-heating-zone';
import Basic                    from './model-basic';

/**
 * defa.models.Zone
 * The DEFA Zone model.
 * @version 1.2.0
 */
const channel = Bb.Radio.channel('objects');

const ON_OFF       = '1';
const TEMP_CONFIG  = '2';
const THERMOSTAT   = '3';
const DUTY_CYCLE   = '4';
const HEATING_ZONE = '5';
const BASIC        = '6';

const Zone = EndpointModel.extend( {

	
	defaults: _.extend({}, EndpointModel.prototype.defaults,
	{
		clusterModels: [],

		// maxCount The maximum number of zones
		zoneNumber: null,
	}),

	//Use the model marcos written above (line 16 to 21)
	getModel: function( modelConst ) {
		return this.get('clusterModels')[modelConst];
	},
	
	_getModels: function() {
		if(this.get('clusterModels').length === 0) {
			let modelArray = [];

			modelArray[ON_OFF]        = new OnOff();
			modelArray[THERMOSTAT]    = new Thermostat();
			modelArray[DUTY_CYCLE]    = new DutyCycle();
			modelArray[HEATING_ZONE]  = new HeatingZone();
			if(channel.request('unitFeatureSets').get(this.get('unitId')).isPro()){
				modelArray[TEMP_CONFIG]   = new TemperatureConfiguration();
				modelArray[BASIC]         = new Basic();
			}

			for(let index in modelArray) {
				modelArray[index].set({zoneNumber: this.get('zoneNumber')});
				modelArray[index].set({unitId: this.get('unitId')});
				modelArray[index].set({id: index+1}); // should this model have its own url and fetch which fetches the zoneId and the runs the endmodels fetch?
			}

			this.set({clusterModels: modelArray});
		}

		//Return zone models
		return this.get('clusterModels')
	},
	
	getTargetTemperature: function(){
		return this.getModel(ON_OFF ).get('onOff')
			   ? this.getModel(THERMOSTAT).get('currentCoolingSetpoint')
			   : this.getModel(THERMOSTAT).get('currentHeatingSetpoint')
	},
	
	tempUnit() {
		switch ( this.getModel(HEATING_ZONE).get('zoneMode') ) {
			case 'regulator':
				return '%';
			case 'thermostat':
				return '°';
		}
		return '';
	},
	
	
	hasThermostat:function(){
		return this.getModel(THERMOSTAT).get( 'localTemperature' );
	},
	
	isThermostatOrRegulator(){
		let mode = this.getModel(HEATING_ZONE).get('zoneMode');
		return mode === 'regulator' || mode === 'thermostat';
	},
	

});

export default Zone;
